var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { ScreenReaderOnly } from '../screen-reader-only';
import { Paragraph } from '../paragraph';
import { NotificationCard } from '../notification-card';
import { Heading } from '../heading';
import { toastStyle, titleStyle, descriptionStyle } from './styles';
function Card(_a) {
    var title = _a.title, variant = _a.variant, description = _a.description, onClose = _a.onClose;
    function renderAnnouncement() {
        switch (variant) {
            case 'success':
                return _jsx(ScreenReaderOnly, { children: "Success:" });
            case 'warning':
                return _jsx(ScreenReaderOnly, { children: "Warning:" });
            case 'error':
                return _jsx(ScreenReaderOnly, { children: "Error:" });
            default:
                return null;
        }
    }
    return (_jsxs(NotificationCard, __assign({ variant: variant, onClose: onClose, closable: true, css: toastStyle() }, { children: [_jsxs(Heading, __assign({ as: "h2", size: "medium", css: titleStyle() }, { children: [renderAnnouncement(), title] })), description && (_jsx(Paragraph, __assign({ variant: "secondary", css: descriptionStyle() }, { children: description })))] })));
}
export default Card;
